import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="text-xs uppercase tracking-[0.2em] text-ink font-semibold">← Railway Careers UK</Link>
        <div className="mt-4 bg-card border border-border rounded-lg p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-sent">
              <CheckCircle2 className="w-12 h-12 text-lime-600 mx-auto" />
              <h1 className="font-display font-extrabold text-ink text-2xl mt-5">Check your inbox</h1>
              <p className="mt-3 text-sm text-muted-foreground">
                If an account exists for <strong className="text-ink">{email}</strong>, we've sent a
                password-reset link to it. The link is valid for one hour.
              </p>
              <Link to="/employer-portal/login" className="inline-block mt-6 px-5 py-2.5 rounded-full bg-navy text-bone font-semibold hover:bg-lime-600 hover:text-ink transition-colors">Back to sign in</Link>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-form">
              <Mail className="w-10 h-10 text-amber-600" />
              <h1 className="font-display font-extrabold text-ink text-2xl mt-4">Reset password</h1>
              <p className="mt-2 text-sm text-muted-foreground">Enter the email tied to your Railway Careers UK account and we'll send a one-hour reset link.</p>
              <div className="mt-6">
                <Label>Work email</Label>
                <Input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="forgot-email" />
              </div>
              <Button type="submit" disabled={loading} className="w-full mt-5 bg-navy text-bone hover:bg-lime-600 hover:text-ink font-semibold" data-testid="forgot-submit">
                {loading ? "Sending…" : "Send reset link"}
              </Button>
              <div className="mt-4 text-center text-sm text-muted-foreground">
                <Link to="/employer-portal/login" className="text-ink font-semibold underline-offset-4 hover:underline">← Back to sign in</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
